import { Box, SimpleLayout, useLayout } from '@approvalmax/ui/src/components';
import { browserHelpers, hooks } from '@approvalmax/utils';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { amplitudeService } from 'services/amplitude';
import { routingService } from 'services/routing';
import { storageService } from 'services/storage';
import { SsoPanel } from 'shared/components';
import { Workspace } from 'urlBuilder';

import { Content } from './resources/components';
import { useAdaptation } from './resources/hooks/useAdaptation';
import { messages } from './resources/messages';

const Page = () => {
    useLayout({ containerMinSize: 'xxsmall' });

    const [app] = hooks.useQueryParam<Workspace>('app');
    const authenticated = storageService.authenticated();

    const { ssoPanelSpacing } = useAdaptation();

    useEffect(() => {
        if (authenticated) {
            routingService.replaceToDefaultPath();
        } else {
            amplitudeService.sendData('signup: land on register page', {
                signup_version: browserHelpers.isMobile() ? 'mobile' : 'desktop',
            });
        }
    }, [authenticated]);

    if (authenticated) return null;

    return (
        <SimpleLayout size='small'>
            <Helmet>
                <title>{messages.title}</title>

                <meta name='description' content={messages.description} />
            </Helmet>

            <SimpleLayout.Content>
                <Content />
            </SimpleLayout.Content>

            <SimpleLayout.Footer>
                <Box spacing={ssoPanelSpacing}>
                    <SsoPanel variant='register' app={app} />
                </Box>
            </SimpleLayout.Footer>
        </SimpleLayout>
    );
};

export default Page;
